function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      if (typeof reader.result === 'string' && reader.result.length > 0) {
        resolve(reader.result)
        return
      }
      reject(new Error('Image preview generation failed'))
    }
    reader.onerror = () => reject(new Error('Image preview generation failed'))
    reader.readAsDataURL(blob)
  })
}

async function decodeImageDataUrl(dataUrl: string): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
      if (image.naturalWidth > 0 && image.naturalHeight > 0) {
        resolve()
        return
      }
      reject(new Error('Image appears corrupted — please choose a different photo'))
    }
    image.onerror = () => reject(new Error('Image appears corrupted — please choose a different photo'))
    image.src = dataUrl
  })
}

export async function assertDecodableImage(blob: Blob): Promise<void> {
  if (!blob.type.startsWith('image/')) {
    throw new Error('Unsupported photo format')
  }

  if (typeof createImageBitmap === 'function') {
    try {
      const bitmap = await createImageBitmap(blob)
      bitmap.close()
      return
    } catch {
      // Fall back to the data URL decode path below so browser-specific
      // bitmap failures do not reject a still-decodable image.
    }
  }

  const dataUrl = await blobToDataUrl(blob)
  await decodeImageDataUrl(dataUrl)
}
